export default __webpack_public_path__ + "static/media/apply-jobs.345a9555.png";